function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "i@3x");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "footer",
  transform: "translate(-206.000000, -245.000000)"
}, React.createElement("g", {
  id: "Group-6",
  fill: "#A6A6B4"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 1440,
  height: 339
})), React.createElement("g", {
  id: "ins",
  transform: "translate(209.000000, 248.000000)"
}, React.createElement("rect", {
  id: "Rectangle-39",
  stroke: "#FFFFFF",
  strokeWidth: 0.96,
  x: 0,
  y: 0,
  width: 12.5666667,
  height: 12.5666667,
  rx: 3.84
}), React.createElement("circle", {
  id: "Oval-2",
  stroke: "#FFFFFF",
  strokeWidth: 0.96,
  cx: 6.28333333,
  cy: 6.28333333,
  r: 2.76466667
}), React.createElement("circle", {
  id: "Oval-3",
  fill: "#FFFFFF",
  cx: 9.802,
  cy: 2.76466667,
  r: 1
}))));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.be4a73df.svg";
export { ForwardRef as ReactComponent };